import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "q-pa-lg text-body1" }
const _hoisted_2 = { class: "text-weight-bold q-mb-sm" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " The client has initiated the import process. You will be notified by email when the posts are available for your review. ", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, " A member of our support team will contact you via email to help you complete the import process. ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "If you do not need support, you can import your posts by clicking below.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_import_posts_btn = _resolveComponent("import-posts-btn")!
  const _component_app_user = _resolveComponent("app-user")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(" Import Process Initiated "),
      _createVNode(_component_q_icon, {
        name: "fa fa-headset",
        size: "2rem",
        class: "on-right"
      })
    ]),
    _createVNode(_component_app_user, null, {
      default: _withCtx(({ isCustomer, isClient }) => [
        isCustomer
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : isClient
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _createVNode(_component_import_posts_btn, {
                  account: _ctx.account,
                  color: "primary",
                  label: "Import Posts",
                  rounded: ""
                }, null, 8, ["account"])
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}